import { Camera, Sparkle } from '@phosphor-icons/react';
import type { AssignmentFormat } from '../data/teacher-dummy';

const ASSIGNMENT_FORMAT_LABELS: Record<AssignmentFormat, string> = {
  closed: 'Devoir photo',
  interactive: 'Interactif',
};

export function assignmentFormatLabel(format: AssignmentFormat): string {
  const label = ASSIGNMENT_FORMAT_LABELS[format];
  if (label !== undefined) return label;
  if (import.meta.env.DEV) {
    throw new Error(`Libellé manquant pour le format de devoir "${format}"`);
  }
  return format;
}

export function AssignmentFormatIcon({ format }: { format: AssignmentFormat }) {
  const props = { size: 14, weight: 'regular' as const };
  return format === 'interactive' ? <Sparkle {...props} /> : <Camera {...props} />;
}
